export const RECENT_PRESET_NAME = 'SUGGESTION_RECENT_SEARCH';

export const TOOLTIP_SLOT_PROPS = {
  popper: {
    modifiers: [
      {
        name: 'offset',
        options: {
          offset: [-10, -40],
        },
      },
    ],
  },
};
